import React from 'react';
import HeadLineThird from '../../atoms/HeadLineThird';
import ReservationAdvanceCard from '../../molecules/ReservationAdvanceCard';
import ReservationAdvanceMessageCard from '../../molecules/ReservationAdvanceMessageCard';
import { MasterInfoState, getMessageFromMasterInfo, MESSAGE_MASTER_KEYS } from '../../../redux/reducers/MasterInfoReducer';
import ReservationAdvanceCardList from '../../molecules/ReservationAdvanceCardList';

export interface AdvancePreparationList {
  label: string;
  count: number;
}

export interface AdvancePreparationProps {
  befCalllist: AdvancePreparationList[];
  advancePreparationCrewHearinglist: AdvancePreparationList[];
  advancePreparationInquirylist: AdvancePreparationList[];
  lineContactList: AdvancePreparationList[];
  isPastDay: boolean;
  masterInfo: MasterInfoState;
}

const AdvancePreparation: React.FC<AdvancePreparationProps> = ({
  befCalllist,
  advancePreparationCrewHearinglist,
  advancePreparationInquirylist,
  lineContactList,
  isPastDay,
  masterInfo,
}) => {
  return (
    <div>
      <HeadLineThird text='事前準備' className='headline-4 u-mb8' data-testid='advance-preparation--title' />
      <div className='u-flex'>
        <ReservationAdvanceCardList
          cardList={[
            {
              title: '架電',
              itemList: befCalllist,
              hasBorder: false,
            },
            {
              title: 'LINE',
              itemList: lineContactList,
              hasBorder: true,
            },
          ]}
        />
        <ReservationAdvanceCard title='クルーヒアリング' itemList={advancePreparationCrewHearinglist} />
        {isPastDay ? (
          <ReservationAdvanceMessageCard title={'照会'} message={getMessageFromMasterInfo(masterInfo, MESSAGE_MASTER_KEYS.M_0021)} />
        ) : (
          <ReservationAdvanceCard title={'照会'} itemList={advancePreparationInquirylist} />
        )}
      </div>
    </div>
  );
};
export default AdvancePreparation;
